import React from 'react';
import { Link } from 'react-router-dom';
import ThreadStatusBadges from '../../../components/ThreadStatusBadges/ThreadStatusBadges';
import styles from '../AnimatorDashboard.module.css';

const AnimatorThreadRow = ({ thread }) => {
  const animation = thread.animation || {};

  return (
    <Link to={`/threads/${thread.slug || thread.id}`} className={styles.threadRow}>
      <div className={styles.threadRowMain}>
        <span className={styles.threadTitle}>{thread.title}</span>
        <div className={styles.threadMeta}>
          {thread.author?.pseudo && <span>Créé par {thread.author.pseudo}</span>}
          {animation.lastPostAt && (
            <span>
              Dernière animation :
              {' '}
              {new Date(animation.lastPostAt).toLocaleDateString('fr-FR')}
            </span>
          )}
          {animation.lastAnimator?.pseudo && (
            <span>par {animation.lastAnimator.pseudo}</span>
          )}
          {animation.lastNpc?.name && (
            <span>en {animation.lastNpc.name}</span>
          )}
          {thread.universe?.name && <span>{thread.universe.name}</span>}
        </div>
      </div>
      <div className={styles.threadRowBadges}>
        {thread.isMine && <span className={styles.mineBadge}>Mon animation</span>}
        {animation.isAiAssisted && <span className={styles.aiBadge}>IA</span>}
        <ThreadStatusBadges thread={thread} />
        {thread.postCount != null && (
          <span className={styles.postCount}>{thread.postCount} posts</span>
        )}
      </div>
    </Link>
  );
};

export default AnimatorThreadRow;
